/* eslint-disable no-unused-vars */
const getUrlVars = () => {
  const vars = {};
  const parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    (m, key, value) => {
      vars[key] = value;
    },
  );
  return vars;
};
export default getUrlVars;
